module.exports = __webpack_public_path__ + "img/footer-fb.7ae065b9.svg";